import { useState,useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as reqTypes from '../../redux/actionType'
function useTitle(val) { 
  const dispatch=useDispatch();
   useEffect(()=>{
        dispatch({ type: reqTypes.SET_TITLE, payload:val});
   },[]);
}
export {useTitle};